<template>
    <div>
        <div v-if="status === '3'" style="display: flex; flex-direction: column;">
            <van-image with="100%" height="auto" :src="src"/>
            <div style="background-color: white;">
                <van-cell-group>
                    <van-cell title="所在地区" is-link arrow-direction="down" :value="form.formAddress"
                              @click="showAreaPop = true"/>
                    <van-cell title="身份类型" is-link arrow-direction="down" :value="form.formType"
                              @click="showPicker = true"/>
                    <van-field v-model="form.participateTime" type="number" label="成立/工作年限" placeholder="请输入工作年限" input-align="right">
                        <div slot="right-icon">年</div>
                    </van-field>
                    <van-cell title="自我简介">
                        <van-field v-model="form.userIntroduce" slot="label" type="textarea"
                                   placeholder="请简要进行自我介绍，包括学习、工作经验，个人技 能、证书、特长等方面" style="padding: 0;"></van-field>
                    </van-cell>
                    <van-cell title="申请缘由">
                        <van-field v-model="form.applyCause" slot="label" type="textarea"
                                   :placeholder="type === '1' ? '请简要讲述您申请成为【心智宝大使】的原因' : '请简要讲述您申请成为【益宝枢纽伙伴】的原因'" style="padding: 0;"></van-field>
                    </van-cell>
                </van-cell-group>
            </div>
            <van-button round type="info" color="linear-gradient(to right, #4587DD, #40B6F8)"
                        style="margin: 30px 10% 30px 10%; width: 80%;"
                        @click="apply">提交申请
            </van-button>

            <van-popup v-model="showAreaPop" position="bottom">
                <div>
                    <van-area :area-list="areaList" @cancel="this.showAreaPop = false" @confirm="areaConfirm"
                              @change="areaChange"/>
                </div>
            </van-popup>

            <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm"
                            @change="onChange"/>
            </van-popup>
        </div>

        <div v-else>
            <div style="width: 100%; background-color: white; display: flex; flex-direction: column; align-items: center; padding: 90px 0;">
                <div style="background-color: #066BEE; width: 36px; height: 40px; border-radius: 50%; padding: 14px 16px;">
                    <van-image width="36px" height="40px" :src="require('@/assets/审核中.png')"/>
                </div>
                <div style="margin-top: 14px; font-size: 14px; color: #333333;">{{status === '0' ? '审核中' : status === '1' ? '审核已通过' : '审核未通过'}}</div>
            </div>
            <div v-if="status !== '1'" style="position: fixed; bottom: 35px; width: 100%; text-align: center; text-decoration:underline; color: #666666; font-size: 14px;"
                 @click="cancelApply">{{status === '0' ? '取消申请' : '重新申请'}}
            </div>
        </div>
    </div>


</template>

<script>

    import Vue from 'vue';
    import {Cell, CellGroup, Field, Image, Area, Popup, Picker, Notify, Toast, Dialog} from 'vant';
    import areaData from '@/utils/area.js'
    import Cookies from 'js-cookie'

    Vue.use(Cell).use(CellGroup).use(Field).use(Image).use(Area).use(Popup).use(Picker).use(Notify).use(Toast).use(Dialog);

    export default {
        name: "ApplyAmbassador",
        data() {
            return {
                type: Cookies.get('type'),
                status: this.$route.query.status || '',
                src: Cookies.get('type') === '1' ? require('@/assets/心智宝大使.jpg') : require('@/assets/枢纽大使.png'),
                areaList: areaData,
                showAreaPop: false,
                showPicker: false,
                form: {
                    userType: Cookies.get('type'),
                    userIntroduce: '',
                    applyCause: '',
                    province: '',
                    city: '',
                    area: '',
                    formAddress: '请选择',
                    formType: '请选择'
                },
                columns: ['机构', '个人']
            }
        },
        methods: {
            areaChange(picker, values, index) {
                this.form.province = values[0].name
                this.form.city = values[1].name
                this.form.area = values[2].name
                this.$set(this.form, 'formAddress', `${this.form.province} ${this.form.city} ${this.form.area}`)
            },
            areaConfirm(values, index) {
                this.form.province = values[0].name
                this.form.city = values[1].name
                this.form.area = values[2].name
                this.$set(this.form, 'formAddress', `${this.form.province} ${this.form.city} ${this.form.area}`)
                this.showAreaPop = false
            },
            onChange(picker, value, index) {
                this.$set(this.form, 'formType', value)
                this.form.applyType = index
            },
            onConfirm(value, index) {
                this.showPicker = false
                this.$set(this.form, 'formType', value)
                this.form.applyType = index
            },
            cancelApply() {
                if (this.status === '2') {
                    this.remove()
                    return;
                }
                Dialog.confirm({
                    title: '提示',
                    message: '是否取消大使申请'
                }).then(() => {
                    this.remove()
                }).catch(() => {
                });
            },
            remove() {
                this.$axios.get('/ambassador/remove', {params: {type: this.$route.query.type}}).then( res => {
                    this.status = res.data.status;
                })
            },
            apply() {
                if (this.form.formAddress === '请选择') {
                    Notify({
                        message: '请选择所在地区',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.formType === '请选择') {
                    Notify({
                        message: '请选择申请类型',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.participateTime.length === 0) {
                    Notify({
                        message: '请填写工作年限',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.userIntroduce.length === 0) {
                    Notify({
                        message: '请填写自我介绍',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.userIntroduce.length > 200) {
                    Notify({
                        message: '自我介绍最多输入200个字符',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.applyCause.length > 200) {
                    Notify({
                        message: '申请意愿最多输入200个字符',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.form.applyCause.length === 0) {
                    Notify({
                        message: '请填写申请意愿',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                this.$axios.post("/ambassador/add", this.form).then(res => {
                    if (res.code == 200) {
                        Toast.success('提交成功')
                        this.$router.back()
                    }
                });
            },
        }

    }
</script>

<style scoped>

</style>
